import {InputNumber as AInputNumber} from 'antd'
import React, {FunctionComponent} from 'react'
import {InputNumberProps} from "antd/lib/input-number";
import classnames from 'classnames'
import './style/index.less'

const InputNumber:FunctionComponent<InputNumberProps> = props => {
  const {prefixCls='gc_', className} = props
  return (
    <AInputNumber {...props} className={classnames(prefixCls+'input_number', className)}></AInputNumber>
  )
}

export default InputNumber
